import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateEtlPackage {
        __typename
        id
        name
        version
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/NewSubscription.js